import styled from 'styled-components';
import { DefaultButton } from '@fluentui/react';
import { ChevronLeft20Filled } from '@fluentui/react-icons';
import { WidgetContainer } from 'src/styles/globalStyles/widgetContainer.styled';
import {
  ArrowDownFilled,
  ArrowUpFilled,
  DismissFilled,
  FilterFilled,
} from '@fluentui/react-icons';

export const WidgetContainerRequest = styled(WidgetContainer)`
  background: transparent;
`;

export const RequestsContainer = styled.ul<{ showMoreRequests: boolean }>`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  padding: 0.25rem;
  padding-left: 0;
  overflow-y: scroll;
  @media (max-width: 1072px) {
    max-height: 10rem;
  }
`;

export const RequestHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #d1d1d1;
  padding: 0.15rem;

  button {
    background: transparent;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    height: 40px;
    color: #5c5b5b;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  button:not(:last-of-type) {
    width: 23%;
  }

  button:first-of-type {
    width: 50px;
    padding-left: 0.5rem;
  }

  button:last-of-type,
  button:first-of-type {
    text-decoration: underline;
    color: #4f52b2;
  }
`;

export const FilterButton = styled(DefaultButton)`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  gap: 0.2rem;
  height: 1.25rem;
  color: ${(props) => props.theme.colorNeutralForeground1};
  &:hover {
    color: ${(props) => props.theme.colorNeutralForeground1};
    background: transparent;
  }
`;

export const ArrowLeft = styled(ChevronLeft20Filled)`
  margin: 0.25rem;
  color: ${(props) => props.theme.filterButtonColor};
  position: absolute;
  left: 0;
`;

export const FilterDivider = styled.div`
  background: ${(props) => props.theme.tableBorders};
  height: 3px;
  width: 100%;
`;

export const FilterListContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ArrowUpIcon = styled(ArrowUpFilled)`
  margin-left: 3px;
`;

export const ArrowDownIcon = styled(ArrowDownFilled)`
  margin-left: 3px;
`;

export const DismissIcon = styled(DismissFilled)`
  margin-right: 3px;
`;

export const FilterIcon = styled(FilterFilled)`
  margin-right: 3px;
`;

export const SpinnerContainer = styled.div`
  width: 100%;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
